export default __webpack_public_path__ + "static/media/user_poap_07.685b23ca.svg";